import { Typography } from 'antd';
import {
  LegalDocumentLayout,
  LegalDocumentList,
} from 'components/LegalDocumentLayout';
import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const WCAG_21_URL = 'https://www.w3.org/TR/WCAG21/';

export const AccessibilityStatement: React.FC = () => {
  const { t } = useTranslation();
  const { Text, Title } = Typography;
  const textStyle = {
    fontSize: '14px',
    fontWeight: 300 as const,
    lineHeight: 1.6,
  };
  const sectionStyle = {
    fontSize: '20px',
    fontWeight: 300 as const,
    lineHeight: 1.4,
  };
  const contactEmail = t('legal.contact-email');

  return (
    <React.Fragment>
      <Helmet>
        <title>{`${t('accessibility.statement.page-title')} | ${process.env.PROJECT_NAME}`}</title>
        <meta
          name="description"
          content={t('accessibility.statement.meta-description')}
        />
      </Helmet>
      <LegalDocumentLayout>
        <Title level={4}>{t('accessibility.statement.heading')}</Title>
        <Text style={{ fontSize: '20px', fontWeight: 300, lineHeight: 1.4 }}>
          {t('legal.service-title')}
        </Text>
        <br />
        <br />
        <br />
        <Text style={{ fontSize: '18px', fontWeight: 300, lineHeight: 1.4 }}>
          {t('legal.website-url')}
        </Text>
        <br />
        <br />
        <Text style={textStyle}>
          {t('accessibility.statement.intro-p1')}
          <br />
          <br />
          {t('accessibility.statement.intro-p2')}
        </Text>
        <br />
        <br />
        <br />
        <Text style={sectionStyle}>
          {t('accessibility.statement.using-heading')}
        </Text>
        <br />
        <br />
        <Text style={textStyle}>
          {t('accessibility.statement.using-p1')}
          <br />
          <br />
          {t('accessibility.statement.using-p2')}
        </Text>
        <LegalDocumentList>
          <li>{t('accessibility.statement.using-item-1')}</li>
          <li>{t('accessibility.statement.using-item-2')}</li>
          <li>{t('accessibility.statement.using-item-3')}</li>
          <li>{t('accessibility.statement.using-item-4')}</li>
          <li>{t('accessibility.statement.using-item-5')}</li>
        </LegalDocumentList>
        <Text style={textStyle}>
          {t('accessibility.statement.using-p3')}
          <br />
          <br />
          {t('accessibility.statement.using-p4')}
        </Text>
        <br />
        <br />
        <br />
        <Text style={sectionStyle}>
          {t('accessibility.statement.how-accessible-heading')}
        </Text>
        <br />
        <br />
        <Text style={textStyle}>
          <a
            href={WCAG_21_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#5e87b0', textDecoration: 'underline' }}
          >
            {t('accessibility.statement.how-accessible-p1')}
          </a>
          <br />
          <br />
          {t('accessibility.statement.how-accessible-p2')}
        </Text>
        <br />
        <br />
        <br />
        <Text style={sectionStyle}>
          {t('accessibility.statement.known-issues-heading')}
        </Text>
        <br />
        <br />
        <Text style={textStyle}>
          {t('accessibility.statement.known-issues-intro')}
        </Text>
        <LegalDocumentList>
          <li>{t('accessibility.statement.known-issue-1')}</li>
          <li>{t('accessibility.statement.known-issue-2')}</li>
          <li>{t('accessibility.statement.known-issue-3')}</li>
          <li>{t('accessibility.statement.known-issue-4')}</li>
        </LegalDocumentList>
        <br />
        <Text style={sectionStyle}>
          {t('accessibility.statement.commitment-heading')}
        </Text>
        <br />
        <br />
        <Text style={textStyle}>
          {t('accessibility.statement.commitment-p1')}
          <br />
          <br />
          {t('accessibility.statement.commitment-p2')}
        </Text>
        <br />
        <br />
        <br />
        <Text style={sectionStyle}>
          {t('accessibility.statement.difficulty-heading')}
        </Text>
        <br />
        <br />
        <Text style={textStyle}>
          {t('accessibility.statement.difficulty-p1-before')}{' '}
          <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
          {t('accessibility.statement.difficulty-p1-after')}
        </Text>
        <br />
        <br />
        <br />
        <Text style={sectionStyle}>
          {t('accessibility.statement.reporting-heading')}
        </Text>
        <br />
        <br />
        <Text style={textStyle}>
          {t('accessibility.statement.reporting-p1-before')}{' '}
          <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
          {t('accessibility.statement.reporting-p1-after')}
        </Text>
        <br />
        <br />
        <br />
        <Text style={textStyle}>
          {t('accessibility.statement.prepared-p1')}
        </Text>
        <br />
        <br />
      </LegalDocumentLayout>
    </React.Fragment>
  );
};

export default AccessibilityStatement;
